'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useNotificationsContext } from 'notifications/hooks/useNotificationsContext/useNotificationsContext'
import { useEffect } from 'react'

import { FEEDBACK_ID } from '../../constants'
import { data } from './data'

export const useFeedback = (
	sendFeedback: boolean,
	onFeedbackSent: () => void
) => {
	const { t } = useLabels()
	const { addNotification } = useNotificationsContext()
	const {
		country: { hasDiscount },
	} = useMasterData()
	const variant = hasDiscount ? 'discount' : 'default'
	const feedbackData = data[variant]
	const notification = {
		id: FEEDBACK_ID,
		title: t(feedbackData.title),
		subtitle: 'subtitle' in feedbackData ? t(feedbackData.subtitle) : undefined,
		icon: feedbackData.icon,
	}

	useEffect(() => {
		if (sendFeedback) {
			addNotification(notification)
			onFeedbackSent()
		}
	}, [sendFeedback])
}
